import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class CuttingToolService extends Service {
	constructor(injector: Injector) {
		super("CuttingTool", injector);
	}
}
